import Swiper, { Pagination, Autoplay } from 'swiper';

export const initSliders = () => {
    const fullSliders = document.querySelectorAll( '.js-full-slider' );
    fullSliders.forEach( slider => {
        new Swiper(slider, {
            modules: [Pagination],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
          });
    } );

    const sliderWhitePapers = document.querySelectorAll( '.js-slider-white-papers' );
    sliderWhitePapers.forEach( slider => {
        new Swiper(slider, {
            modules: [Pagination, Autoplay],
            autoplay: true,
            slidesPerView: 1,
            spaceBetween: 39,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                992: {
                    slidesPerView: 2,
                },
            },
          });
    } );

    const sliderDiscoverHow = document.querySelectorAll( '.js-slider-discover-how' );
    sliderDiscoverHow.forEach( slider => {
        new Swiper(slider, {
            modules: [Pagination, Autoplay],
            autoplay: true,
            slidesPerView: 1,
            spaceBetween: 48,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
          });
    } );
}


// WEBPACK FOOTER //
// ./scripts/modules/slider.js